import React from 'react'
import { FacetSelect } from '../BaseComponents/FacetSelect'

const FacetFilterLocation = () => (
  <FacetSelect
    facetCategory="productFilter"
    filterGroup="Location"
    source="filterLocationFacet"
  />
)

export default FacetFilterLocation
